import { MAX_LENGTH_4000 } from 'Models/Constants';
import * as yup from 'yup';

export const CreateBuildingAccessSchema = yup.object({
    locationId: yup.string().required('Errors.required'),
    note: yup.string().max(MAX_LENGTH_4000, 'Errors.length_4000')
});
